import React from "react";
import SubscriptionInfoPanel from "./SubscriptionInfoPanel/app";
import BrandsInfoPanel from "./BrandsInfoPanel";
import { CreditBalancePanel } from "credits/CreditBalancePanelApp";

interface RightSidePanelProps {
  viewModel: server.viewmodel.SystemSettingsMenuFrontModel
}

const SystemSettingsMenu: React.FC<RightSidePanelProps> = ({ viewModel }) => {
  return (
    <div className="system-settings-menu-wrapper">
      <BrandsInfoPanel brands={viewModel.brands} />
      <SubscriptionInfoPanel
        activeSubscription={viewModel.activeSubscription}
        nextSubscriptionType={viewModel.nextSubscriptionType}
        nextBillingCycle={viewModel.nextBillingCycle}
      />
      <CreditBalancePanel panelType="s1_panel" style={{ maxWidth: 500 }} />
    </div>
  );
};

export default SystemSettingsMenu;
